import { useEffect, useState } from 'react';
import Styles from "./RangeSlider.module.css";


function RangeSlider({ min="0",max="1",step="0.1",setValue=()=>{},title="Value",defaultValue=0 }) {
  const [sliderValue, setSliderValue] = useState(defaultValue);

  const handleSliderChange = (e) => {
    setSliderValue(e.target.value);
    setValue(e.target.value);
  };

  useEffect(()=>{
    setSliderValue(defaultValue);
  },[defaultValue]);

  return (
    <div>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={sliderValue}
        onChange={handleSliderChange}
        className={Styles.sliderRange}
      />
      <p>{title}: {sliderValue}</p>
    </div>
  );
}

export default RangeSlider;
